
import {
  INIT_ATTRIBUTE_INFO,
  REQUEST_ATTRIBUTE_START,
  REQUEST_ATTRIBUTE_SUCCESS,
  REQUEST_ATTRIBUTE_FAIL,
} from '../actions/attribute';

export const initialState = { error: null, data: null, isLoading: false }

export const reducer = (state = initialState, action) => {

  const { type, data, payload, error } = action;

  switch (type) {

    case REQUEST_ATTRIBUTE_START:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.req, isLoading: true, type } }
      }

    case REQUEST_ATTRIBUTE_SUCCESS:
      {
        // console.log(type, { state, action, payload })
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case REQUEST_ATTRIBUTE_FAIL:
      {
        /*console.log(type, { state, action, payload })*/
        return { ...state, data: { ...payload.res, isLoading: false, type } }
      }

    case INIT_ATTRIBUTE_INFO:
      {
        return initialState;
      }

    default:
      {
        return { ...state };
      }
  }
};

export default reducer;
